<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">5</h2>
<p class="vers"><span>Ich bitte</span> nur um ein
wenig Geduld,<br class="calibre1"/>
um an deiner Seite zu sitzen, das Werk,<br class="calibre1"/>
das ich wirke, wird später vollendet.</p>
<p class="vers">Ferne dem Schaun auf dein Antlitz,<br class="calibre1"/>
kennt mir das Herz nicht Ruhe noch Rast;<br class="calibre1"/>
und mein Werk wird endloses Mühn<br class="calibre1"/>
am uferlosen Meere der Mühe.</p>
<p class="vers">Heut kam der Sommer ans Fenster<br class="calibre1"/>
mit seinem Summen und Surren, die<br class="calibre1"/>
Bienen singen von Minne am Hofe des<br class="calibre1"/>
blühenden Haines.</p>
<p class="vers">Nun ist es Zeit, um stille zu sitzen von<br class="calibre1"/>
Antlitz zu Antlitz mit dir und dir zu singen<br class="calibre1"/>
des Lebens Widmung in dieser schweigenden,<br class="calibre1"/>
überströmenden Muße. <a id="page8" title="wedi/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?c304c5ea